import React, { useState } from 'react'
import { useWordPressAgendas } from '../uses/useWordpressAgendas'
import { useAgendaCategory } from '../uses/useAgendaCategory'
import AgendaFullPage from './AgendaFullPage'

const months = [
  'Janvier',
  'Février',
  'Mars',
  'Avril',
  'Mai',
  'Juin',
  'Juillet',
  'Août',
  'Septembre',
  'Octobre',
  'Novembre',
  'Décembre',
]

const AgendaCategory = ({ id }) => {
  const category = useAgendaCategory(id)
  return (
    <div className="events-category">
      {category.node.name}
      <i className={`icon-category icon-${category.node.slug}`} />
    </div>
  )
}

const AgendaGrid = ({ page }) => {
  const agendas = useWordPressAgendas()

  const [agenda, setAgenda] = useState(null)
  const [agendaIndex, setAgendaIndex] = useState(null)

  if (typeof window !== 'undefined') {
    const currentIndex = agendas.findIndex(
      agenda => agenda.node.slug == window.location.hash.replace('#', '')
    )

    if (currentIndex !== agendaIndex) {
      setAgenda(currentIndex !== -1 ? agendas[currentIndex] : null)
      setAgendaIndex(currentIndex)
    }
  }

  const setSelectedAgenda = index => {
    if (index === null && typeof window !== 'undefined') {
      setAgenda(null)
      return history.pushState('', document.title, window.location.pathname)
    }

    if (index > agendas.length - 1) {
      index = 0
    }

    if (index < 0) {
      index = agendas.length - 1
    }

    window.location.hash = agendas[index].node.slug
    setAgendaIndex(index)
    setAgenda(agendas[index])
  }

  let prevDate = null
  return (
    <React.Fragment>
      <section className="events-wrapper">
        {agendas.map((item, index) => {
          let date = new Date(item.node.acf.customdate * 1000)
          let newMonth = prevDate !== date.getMonth()
          prevDate = date.getMonth()
          return (
            <React.Fragment key={index}>
              {newMonth && (
                <article className="events-item month-marker">
                  <a className="inner">
                    <div className="inner-wrapper">
                      <h2 className="events-title">
                        {months[date.getMonth()]}
                      </h2>
                    </div>
                  </a>
                </article>
              )}
              <article className="events-item">
                <a
                  onClick={e => {
                    e.preventDefault()
                    setSelectedAgenda(index)
                  }}
                  href="#"
                  className="inner"
                >
                  <div className="inner-wrapper">
                    <h2
                      className="events-title"
                      dangerouslySetInnerHTML={{ __html: item.node.title }}
                    />
                    {item.node.agenda_category.length !== 0 && (
                      <AgendaCategory id={item.node.agenda_category[0]} />
                    )}
                  </div>
                </a>
              </article>
            </React.Fragment>
          )
        })}
      </section>
      <AgendaFullPage
        agenda={agenda}
        agendaIndex={agendaIndex}
        setSelectedAgenda={setSelectedAgenda}
      />
    </React.Fragment>
  )
}

export default AgendaGrid
